import { TranslateService } from '@ngx-translate/core';

/** Prefixo das chaves: shared.editor.dataTags.link_client_name */
export const DATA_TAG_I18N_PREFIX = 'shared.editor.dataTags';

export function getDataTagI18nKey(tag: string): string {
    const normalized = tag.replace(/^\$/, '').trim();
    return `${DATA_TAG_I18N_PREFIX}.${normalized}`;
}

/** Rótulo legível quando não há entrada em shared.editor.dataTags (ex.: link_client_name → Nome do cliente). */
export function humanizeDataTagKey(tag: string): string {
    const normalized = tag.replace(/^\$/, '').trim();
    const stripped = normalized.startsWith('link_') ? normalized.slice(5) : normalized;
    return stripped
        .split('_')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

/**
 * Rótulo exibido no editor/viewer. A chave de tradução é o próprio valor salvo em dataTag.
 */
export function getDataTagLabel(
    translate: TranslateService,
    tag: string,
    fallback?: string
): string {
    const key = getDataTagI18nKey(tag);
    const translated = translate.instant(key);
    if (translated !== key) return translated;
    if (fallback?.trim()) return fallback.trim();
    return humanizeDataTagKey(tag);
}

/** Dica opcional no tooltip (shared.editor.dataTagsHint.{tag}_description ou .{tag}). */
export function getDataTagHint(translate: TranslateService, tag: string): string | undefined {
    const keys = [
        `shared.editor.dataTagsHint.${tag}_description`,
        `shared.editor.dataTagsHint.${tag}`,
    ];
    for (const key of keys) {
        const translated = translate.instant(key);
        if (translated !== key) return translated;
    }
    return undefined;
}
